/**
 * Explore Unknown — boss battle mulligan intro (replaces faction VS circles)
 * and battle HUD opponent name/title overrides.
 * Maps global mission index → i18n keys under `exploreUnknownPage.bossIntro.*`
 * and `exploreUnknownPage.bossTitle.*`.
 */

const EXPLORE_UNKNOWN_BOSS_INTRO_TRANSLATION_KEY_BY_MISSION_INDEX = Object.freeze({
  10: 'exploreUnknownPage.bossIntro.innocence',
  16: 'exploreUnknownPage.bossIntro.fear',
  23: 'exploreUnknownPage.bossIntro.pride',
  27: 'exploreUnknownPage.bossIntro.hunger',
  33: 'exploreUnknownPage.bossIntro.thirst',
  40: 'exploreUnknownPage.bossIntro.mirth',
  46: 'exploreUnknownPage.bossIntro.harmony',
  53: 'exploreUnknownPage.bossIntro.awe',
  59: 'exploreUnknownPage.bossIntro.mortality',
  68: 'exploreUnknownPage.bossIntro.creation',
  73: 'exploreUnknownPage.bossIntro.instinct',
  74: 'exploreUnknownPage.bossIntro.kinship',
  75: 'exploreUnknownPage.bossIntro.humanity',
});

const EXPLORE_UNKNOWN_BOSS_TITLE_TRANSLATION_KEY_BY_MISSION_INDEX = Object.freeze({
  10: 'exploreUnknownPage.bossTitle.innocence',
  16: 'exploreUnknownPage.bossTitle.fear',
  23: 'exploreUnknownPage.bossTitle.pride',
  27: 'exploreUnknownPage.bossTitle.hunger',
  33: 'exploreUnknownPage.bossTitle.thirst',
  40: 'exploreUnknownPage.bossTitle.mirth',
  46: 'exploreUnknownPage.bossTitle.harmony',
  53: 'exploreUnknownPage.bossTitle.awe',
  59: 'exploreUnknownPage.bossTitle.mortality',
  68: 'exploreUnknownPage.bossTitle.creation',
  73: 'exploreUnknownPage.bossTitle.instinct',
  74: 'exploreUnknownPage.bossTitle.kinship',
  75: 'exploreUnknownPage.bossTitle.humanity',
});

/**
 * @param {number|string|null|undefined} missionIndex
 * @returns {string|null} i18n key when this mission uses the boss name bar intro
 */
export function getExploreUnknownBossIntroTranslationKey(missionIndex) {
  if (missionIndex == null) return null;
  const idx = Number(missionIndex);
  if (!Number.isInteger(idx) || idx < 1) return null;
  return EXPLORE_UNKNOWN_BOSS_INTRO_TRANSLATION_KEY_BY_MISSION_INDEX[idx] ?? null;
}

/**
 * @param {number|string|null|undefined} missionIndex
 * @returns {string|null} i18n key for the boss-specific battle HUD title
 */
export function getExploreUnknownBossTitleTranslationKey(missionIndex) {
  if (missionIndex == null) return null;
  const idx = Number(missionIndex);
  if (!Number.isInteger(idx) || idx < 1) return null;
  return EXPLORE_UNKNOWN_BOSS_TITLE_TRANSLATION_KEY_BY_MISSION_INDEX[idx] ?? null;
}

export {
  EXPLORE_UNKNOWN_BOSS_INTRO_TRANSLATION_KEY_BY_MISSION_INDEX,
  EXPLORE_UNKNOWN_BOSS_TITLE_TRANSLATION_KEY_BY_MISSION_INDEX,
};
